<template>
  <div class="content">
    <div class="container-fluid">
      <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header card-header-info">
                <div class="row">
                  <div class="col-md-12">
                    <h4 class="card-title ">Detail Secret Mikrotik</h4>
                    <p class="card-category">Berikut ini daftar Mikrotiku</p>
                  </div>
                </div>
              </div>
              <div class="card-body" >
                <div class="table-responsive">
                  <table class="table">
                    <thead class=" text-info">
                      <th width="40px">No.</th>
                      <th>Nama</th>
                      <th>Comment</th>
                    </thead>
                    <tbody v-show="theGet.data.loading">
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                      <tr>
                        <td colspan="8"><Loading></Loading></td>
                      </tr>
                    </tbody>
                    <tbody>
                      <tr v-for="(u, index) in theGet.data.List">
                        <td>{{ index+1 }}</td>
                        <td>{{u.name}}</span></td>
                        <td>{{u.comment}}</span></td>
                      </tr>
                      <tr v-if="theGet.data.List == null">
                        <td></td>
                        <td>Tidak ada Data </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
      </div>

    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { reactive } from '@vue/composition-api'
import myGlobal from '@/globalFunc/myGlobal' 
import inter from '@/globalFunc/Interface' 
import Loading from '@/globalFunc/Loading' 

export default {
  name: 'Beranda',
  components: {
    'Loading': Loading
  }, 
  setup() {
    const data = reactive({
      // modalDetail: false,
      // modalHapus: false

      /* modal edit tarif */
    })

    const theGet = {
      data: reactive({
        List: [],
        ip: '',
        username: '',
        password: '',
        via: '',
        loading: true,
        page: ''
      }),
      datae() {
        //console.log(sessionStorage.getItem('admin'));
			  // for filter
        /*
        var datax = {
            token: 'TangTung '+sessionStorage.getItem('myToken')
        }
			
			  var apiUrl = inter.MiktorikList();
        myGlobal.call(datax,apiUrl).then(x => {
          //console.log(JSON.stringify(x));
          if (x.status == true) {
              this.data.List = x.data;
          } else {
              //alert(x.pesan);
          }
        })
        */
       
        var datax = {
            ip: this.data.ip,
            username:this.data.username,
            password:this.data.password,
            via:this.data.via
        }

        var apiUrl;
        if (this.data.page == 'secret') {
            apiUrl = "list-pelanggan.php";
        } else if (this.data.page == 'active') {
            apiUrl = "list-pelanggan-aktif.php";
        } else if (this.data.page == 'nonactive') {
            apiUrl = "list-pelanggan-nonaktif.php";
        }

        myGlobal.callMikrotik(datax,apiUrl).then(x => {
          
          // console.log(JSON.stringify(x));

          this.data.loading = false;
          if (x.status == true) {
              this.data.List = x.data;
          } else {

          }
        })
      }
    }
    return {
      data, 
      theGet
    }
  },
  mounted () {
    var route = this.$route.params;
    this.theGet.data.ip = route.ip;
    this.theGet.data.username = route.username;
    this.theGet.data.password = route.password;
    this.theGet.data.via = route.via;
    this.theGet.data.page = route.page;

    if (route.page == 'secret') {
        document.title = "Detail Secret Mikrotik";
    } else if (route.page == 'active') {
        document.title = "Detail Active Mikrotik";
    } else if (route.page == 'nonactive') {
        document.title = "Detail Non Active Mikrotik";
    }

    this.theGet.datae();
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
.modal {
	display: inherit;
}
</style>



// WEBPACK FOOTER //
// src/components/mikrotik/detail-secret.vue